import React, {useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useLoading} from "../../components/context/LoadingContext";
import { Button, Chip, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import * as xlsx from 'xlsx';
import { db } from "../../components/Firebase/Firebase"
import { collection, doc, writeBatch } from 'firebase/firestore';
import './EventAthletePreloadPage.css';

const EventAthletePreloadPage = () => {
    const {eventId} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useLoading();
    const [files, setFiles] = useState([]);

    const handleAddNewFiles = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
        event.target.value = '';
    };

    const handleFileDelete = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter(file => file.name !== fileName));
    };

    const handleProcessFiles = async (files) => {
        setIsLoading(true);

        if (files.length === 0) {
            console.warn("No files to process");
            setIsLoading(false);
            return;
        }

        try {
            const resultsCollectionRef = collection(db, `eventTimingResults/${eventId}/results`);

            for (const file of files) {
                const arrayBuffer = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (event) => resolve(event.target.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsArrayBuffer(file);
                });
                const workbook = xlsx.read(arrayBuffer, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = xlsx.utils.sheet_to_json(sheet, { header: 1, range: 1 });

                let batch = writeBatch(db);
                let operationCounter = 0;

                for (const row of rows) {
                    const bib = `${row[0]}`;
                    const name = `${row[1]} ${row[2]}`.trim();
                    const country = `${row[3]}`;
                    const city = `${row[4]}`;

                    const searchParts = [
                        ...generateSearchParts(name),
                        ...generateSearchParts(bib)
                    ];

                    const bibDocData = {
                        bib: bib,
                        name: name,
                        country: country || null,
                        city: city || null,
                        splits: [],
                        searchParts: searchParts
                    };

                    const docRef = doc(resultsCollectionRef, bib.toString());
                    batch.set(docRef, bibDocData);
                    operationCounter++;

                    if (operationCounter === 500) {
                        await batch.commit();
                        console.log('Committed a batch of 500 operations');
                        batch = writeBatch(db);
                        operationCounter = 0;
                    }
                }

                if (operationCounter > 0) {
                    await batch.commit();
                    console.log(`Committed the final batch of ${operationCounter} operations`);
                }
            }

            setIsLoading(false);
            console.log("All files processed and uploaded successfully.");
            alert("All files processed and uploaded successfully.");
            navigate('/events');
        } catch (error) {
            setIsLoading(false);
            console.error("Error processing or uploading data:", error);
            alert("Error processing or uploading data.");
        }
    };

    const generateSearchParts = (input) => {
        const searchParts = [];
        if (typeof input !== 'string') {
            input = String(input || "");
        }

        input = input.toLowerCase();

        const words = input.split(" ");
        for (const word of words) {
            if (word.length < 3) {
                for (let i = 1; i <= word.length; i++) {
                    searchParts.push(word.slice(0, i));
                }
            } else {
                for (let i = 3; i <= word.length; i++) {
                    searchParts.push(word.slice(0, i));
                }
            }
        }

        return searchParts;
    };

    return (
        <div className='right-content'>
            <form>
                <div className='card shadow border-0'>
                    <div className='form-group'>
                        <h4 className='hd'>Старт: {eventId}</h4>
                    </div>
                    <Button
                        className='logInButton w-25'
                        variant="contained"
                        component="label"
                    >
                        Добавить файлы с участниками
                        <input
                            type="file"
                            multiple
                            hidden
                            onChange={handleAddNewFiles}
                        />
                    </Button>

                    {/* Display the list of uploaded files */}
                    <div className="file-list w-25">
                        {files.map((file, index) => (
                            <Box key={index} className="file-item">
                                <Chip
                                    label={file.name}
                                    onDelete={() => handleFileDelete(file.name)}
                                    deleteIcon={<CloseIcon style={{ color: '#000' }} />}
                                    sx={{
                                        backgroundColor: '#CEFC4C',
                                        color: '#000',
                                        marginBottom: '5px',
                                        width: '100%',
                                        justifyContent: 'space-between'
                                    }}
                                />
                            </Box>
                        ))}
                    </div>

                    <Button
                        className='logInButton w-25'
                        variant="contained"
                        component="label"
                        type="button"
                        onClick={() => handleProcessFiles(files)}
                    >
                        Обработать файлы
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default EventAthletePreloadPage;